import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"expand, window, layout"} maskId="square-filled-radius-0-stroke-1-IconExpand"><path d="M12 13V22H2V13H12Z" fill="currentColor"/><path d="M22 3V16H14.25V15H21V4H4V10.75H3V3H22Z" fill="currentColor"/><path d="M18 7V11H17V8.70711L14 11.7071L13.2929 11L16.2929 8H14V7H18Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconExpand;
